import {generateAsyncActionCreators} from '../core/reduxUtils';

const getCategoryBannersActionCreators = generateAsyncActionCreators(
  'GET_CATEGORY_BANNERS',
  (searchTerm, params) => ({
    params: {
      types: searchTerm,
      ...params,
    },
  })
);


const getSearchBannersActionCreators = generateAsyncActionCreators(
  'GET_SEARCH_BANNERS',
  (searchTerm, params) => ({
    params: {
      types: searchTerm,
      ...params,
    },
  })
);

const getTagBannersActionCreators = generateAsyncActionCreators(
  'GET_TAG_BANNERS',
  (searchTerm, params) => ({
    params: {
      types: searchTerm,
      ...params,
    },
  })
);


const actionCreators = {
  getCategoryBanners:{
    ...getCategoryBannersActionCreators,
  },

  getSearchBanners:{
    ...getSearchBannersActionCreators,
  },

  getTagBanners:{
    ...getTagBannersActionCreators,
  },
  resetBannerState() {
    return {
      type: 'RESET_BANNER_STATE',
      payload: {
      },
    };
  },
};


export {
  actionCreators,
  getCategoryBannersActionCreators,
  getSearchBannersActionCreators,
  getTagBannersActionCreators,
};
